import { ScheduleOffsetUnit } from "@simplyk/common";

import { Translate } from "@/common/hooks/useTranslate";
import { DashboardChipVibe } from "@/dashboard-design-system/DashboardChip";

export interface EventReminderChip {
  label: string;
  vibe?: DashboardChipVibe;
  showWhen: "enabled";
}

interface BuildEventReminderChipsParams {
  t: Translate;
  offset: number | undefined;
  offsetUnit: ScheduleOffsetUnit | undefined;
  state: string | undefined;
}

export const buildEventReminderChips = ({
  t,
  offset,
  offsetUnit,
  state,
}: BuildEventReminderChipsParams): EventReminderChip[] => {
  const sentChip: EventReminderChip = {
    label: t("dashboard", "ticketing.setThankYouEmail.reminder.chipLabel.sent"),
    vibe: "positive",
    showWhen: "enabled",
  };
  if (state === "sent_no_future") {
    return [sentChip];
  }
  if (state === "sent_and_upcoming") {
    return [
      sentChip,
      {
        label: t("dashboard", "ticketing.setThankYouEmail.reminder.chipLabel.upcoming"),
        vibe: "neutral",
        showWhen: "enabled",
      },
    ];
  }
  const count = offset ?? 1;
  const key =
    offsetUnit === ScheduleOffsetUnit.Hours
      ? "ticketing.setThankYouEmail.reminder.chipLabel.hours"
      : "ticketing.setThankYouEmail.reminder.chipLabel";
  return [{ label: t("dashboard", key, { count }), showWhen: "enabled" }];
};
